module.exports = __webpack_public_path__ + "static/media/bottle.d4f889eb.svg";